<now-wbsuche-lib-unterrichtsform-basis-facette
  [id]="'digitale-lernform'"
  [label]="'Online Lernen'"
  [modalId]="'digitaleLernformen'"
></now-wbsuche-lib-unterrichtsform-basis-facette>
